module.exports = __webpack_public_path__ + "img/icon-fail.3b1e8c96.png";